import { API_AUTH } from "./common";

const DanhSachQuyKhacApi = {
  list: ({
    sCode,
    sFromDate,
    sToDate,
    sType,
    sUserName,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `ThuChiQuyKhac/danhsach?PageIndex=${pageIndex}&PageSize=${pageSize}&sUserName=${sUserName}&sCode=${sCode}&sFromDate=${sFromDate}&sToDate=${sToDate}&sType=${sType}`,
      {}
    ),
  addorupdate: (data) => API_AUTH.post(`ThuChiQuyKhac/addorupdate`, data),
  deleteQuyKhac: ({ThuChiId}) => API_AUTH.post(`ThuChiQuyKhac/delete?ThuChiId=${ThuChiId}`, {}),

};



export default DanhSachQuyKhacApi;
